var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _rect4, _rect5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomersUpdates = function SvgCustomersUpdates(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    fill: "#E5E3FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 25,
    rx: 5.3,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 17.7998H8.8C7.8058 17.7998 7 16.994 7 15.9998V8.7998H17.2C18.1942 8.7998 19 9.6056 19 10.5998V15.9998C19 16.994 18.1942 17.7998 17.2 17.7998Z",
    fill: "#5A6367"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2002 17.8004C11.2002 17.7311 11.2002 17.6622 11.2002 17.5754C11.2002 17.2028 10.9314 16.9004 10.6002 16.9004C10.269 16.9004 10.0002 17.2028 10.0002 17.5754C10.0002 17.6622 10.0002 17.7311 10.0002 17.8004L11.2002 17.8004Z",
    fill: "#C5C5CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6001 17.8004C16.6001 17.7311 16.6001 17.6622 16.6001 17.5754C16.6001 17.2028 16.3313 16.9004 16.0001 16.9004C15.6689 16.9004 15.4001 17.2028 15.4001 17.5754C15.4001 17.6622 15.4001 17.7311 15.4001 17.8004L16.6001 17.8004Z",
    fill: "#C5C5CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3001 12.4C10.9628 12.4 11.5001 11.8627 11.5001 11.2C11.5001 10.5373 10.9628 10 10.3001 10C9.63736 10 9.1001 10.5373 9.1001 11.2C9.1001 11.8627 9.63736 12.4 10.3001 12.4Z",
    fill: "#C5C5CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2002 15.1C8.2002 13.9402 9.1404 13 10.3002 13C11.46 13 12.4002 13.9402 12.4002 15.1V15.4H8.2002V15.1Z",
    fill: "#C5C5CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6001,
    y: 11.7998,
    width: 4.2,
    height: 0.9,
    rx: 0.45,
    fill: "#C5C5CA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6001,
    y: 13,
    width: 4.2,
    height: 0.9,
    rx: 0.45,
    fill: "#C5C5CA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6001,
    y: 14.2002,
    width: 4.2,
    height: 0.9,
    rx: 0.45,
    fill: "#C5C5CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4 8.8H7V8.2C7 7.537 7.537 7 8.2 7H10.9348C11.4514 7 11.9098 7.3306 12.073 7.8208L12.4 8.8Z",
    fill: "#C5C5CA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomersUpdates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "customers-updates.99715246353b1d6ac302e949894ba8ee.svg";